import axios from "axios";
import { isEn, LOCALE } from "./i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* On /en every read asks the API for the English rendering (server-side translation, see backend/translate.py). */
const withLang = (path) => (isEn ? `${path}${path.includes("?") ? "&" : "?"}lang=en` : path);

export const get = (path) => axios.get(`${API}${withLang(path)}`).then((r) => r.data);
export const post = (path, body) => axios.post(`${API}${withLang(path)}`, body).then((r) => r.data);

/** In-memory promise cache for read-mostly endpoints (share, settings) shared across components. */
const cache = new Map();
export const getCached = (path, ttl = 60_000) => {
  const hit = cache.get(path);
  if (hit && Date.now() - hit.t < ttl) return hit.p;
  const p = get(path).catch((e) => { cache.delete(path); throw e; });
  cache.set(path, { p, t: Date.now() });
  return p;
};

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString(LOCALE, { day: "numeric", month: "long", year: "numeric" });

export const formatDateShort = (iso) =>
  new Date(iso).toLocaleDateString(LOCALE, { day: "numeric", month: "short" });

export const formatTime = (iso) =>
  new Date(iso).toLocaleTimeString(LOCALE, { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Oslo" });

export const formatPrice = (n) => n.toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatPct = (n, sign = true) =>
  `${sign && n > 0 ? "+" : ""}${n.toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`;

export const dateParts = (iso) => {
  const d = new Date(iso + "T12:00:00");
  return {
    day: d.toLocaleDateString(LOCALE, { day: "numeric" }).replace(".", ""),
    month: d.toLocaleDateString(LOCALE, { month: "short" }).replace(".", ""),
    year: d.getFullYear(),
    weekday: d.toLocaleDateString(LOCALE, { weekday: "long" }),
  };
};

export const initials = (name) =>
  name.split(/\s+/).filter(Boolean).filter((_, i, a) => i === 0 || i === a.length - 1).map((w) => w[0]).join("").toUpperCase();

export const isExternal = (url = "") => /^https?:\/\//.test(url);
